import type { AutoOrderQueueModel } from '@models/types'

export const calculateDueDate = (autoOrderQueue: AutoOrderQueueModel): Date => {
  const dueDate = new Date(autoOrderQueue.createdAt)

  dueDate.setTime(dueDate.getTime() + autoOrderQueue.queueDelay * 60 * 60 * 1000)

  return dueDate
}